import React from 'react';
import { Form, Input, Select } from 'antd';

const FormDropdown = ({ name, placeholder, type = 'text', options = [] }) => (
    <Form.Item 
        name={name}
        rules={[
            {
                required: true,
                message: `Please input your ${placeholder.toLowerCase()}!`,
            },
        ]}
        className="w-6/5 mb-1"
    >
        <Select
            placeholder={placeholder}
            className="h-10"
        >
            {options.map((option, index) => (
                <Select.Option key={index} value={option.value}>
                    {option.label}
                </Select.Option>
            ))}
        </Select>
    </Form.Item>
);

export default FormDropdown;
